import { render, staticRenderFns } from "./Tesi.vue?vue&type=template&id=19b939fe&"
import script from "./Tesi.vue?vue&type=script&lang=js&"
export * from "./Tesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports